import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAsRFbi7FrLm-3Scqnh_GLup-4l4yMBlmk",
  authDomain: "argevio-sandbox.firebaseapp.com",
  projectId: "argevio-sandbox",
  storageBucket: "argevio-sandbox.firebasestorage.app",
  messagingSenderId: "178137268144",
  appId: "1:178137268144:web:b930f1530cda5a80042075"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
